export const COURSE_GET = 'COURSE_GET'
export const COURSE_SUGGESTION_GET = 'COURSE_SUGGESTION_GET'
export const COURSE_GET_SUCCESS = 'COURSE_GET_SUCCESS'
export const COURSE_GET_FAILED = 'COURSE_GET_FAILED'
export const COURSE_GET_CLEAR = 'COURSE_GET_CLEAR'
export const COURSE_GET_LOAD = 'COURSE_GET_LOAD'
